import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import React from 'react';
interface PromotedListData {
  data: PromotedAdvertisementData;
  choosed: Array<IPromotedAdvertisement>;
  handleChoosePlan: (chosedFiled: IPromotedAdvertisement) => void;
  setfreePlans: React.Dispatch<React.SetStateAction<IPromotedAdvertisement[]>>;
}
const PromotedList = ({data, choosed, handleChoosePlan}: PromotedListData) => {
  const compareFunction = (a: IPromotedAdvertisement) => {
    if (data.Purchased_packages.some(itemP => a.guid === itemP.guid)) {
      return -1;
    }
    if (!data.Purchased_packages.some(itemP => a.guid === itemP.guid)) {
      return 1;
    }
    return 0;
  };
  return (
    <>
      {data?.total_package.sort(compareFunction).map((item, index) => {
        const deActiveCard = data.Purchased_packages.some(
          itemP => item.guid === itemP.guid,
        );

        return (
          <div
            className={classNames(
              'w-full  flex-col gap-1 px-2 justify-between items-center h-fit  flex rounded-[8px] shadow-sm relative py-2 my-2',
              {
                'bg-farm-shop-100':
                  !deActiveCard &&
                  !item.is_max &&
                  choosed.some(z => z.title === item.title),
              },
              {
                'bg-white':
                  !deActiveCard &&
                  !item.is_max &&
                  !choosed.some(z => z.title === item.title),
              },
              {
                'border-[1px] border-farm-shop-600 bg-farm-shop-50':
                  deActiveCard,
              },
              {
                ' bg-gray-50': item.is_max,
              },
            )}
            key={index}
            onClick={() => {
              !item.is_max && !deActiveCard && handleChoosePlan(item);
            }}
          >
            <div className="flex w-full justify-between items-center text-md font-Medium pr-2">
              <div className="flex gap-2 items-center">
                <div
                  className={classNames(
                    'w-[32] h-[32] flex items-center justify-center rounded-full ',
                    {
                      'bg-gray-100': item.is_max,
                      'bg-farm-shop-50': !item.is_max,
                    },
                  )}
                >
                  <SpanIcon
                    className={classNames(
                      ' text-xl',
                      item.title in iconConvertor && iconConvertor[item.title],
                      {
                        'text-farm-shop-600': !item.is_max,
                        'text-gray-700': item.is_max,
                      },
                    )}
                  />
                </div>
                <span className={classNames({'text-gray-700': item.is_max})}>
                  {item.title}
                </span>
              </div>
              {choosed.some(z => z.title === item.title) && (
                <div>
                  <SpanIcon className="icon-nameCheck-circle1 text-xl text-farm-shop-500" />
                </div>
              )}
            </div>
            <p
              className={classNames('px-2 text-sm font-Regular w-full', {
                'text-gray-600': deActiveCard || item.is_max,
              })}
            >
              {item.description}
            </p>
            <div
              className={classNames(
                'flex  w-full rounded-[8px]  justify-end gap-2 items-center px-2 ',
                {
                  'bg-farm-shop-50': !item.is_max,
                  'bg-gray-100 text-gray-700': item.is_max,
                },
              )}
            >
              {deActiveCard ? (
                <span className=" text-gray-900 text-sm font-Regular w-full">
                  این طرح برای شما فعال است.
                </span>
              ) : (
                <>
                  {item.has_discount && (
                    <div className="bg-red-500 text-xs text-white rounded-sm px-1">
                      {item.discount_percent}%
                    </div>
                  )}
                  {item.has_discount && (
                    <div className="text-gray-400 text-xs ">
                      <span>{item.price.toLocaleString()}</span>
                    </div>
                  )}
                  <div className="flex gap-1 items-center">
                    <span className="text-md font-Regular">
                      {item?.discounted_price
                        ? item?.discounted_price?.toLocaleString()
                        : item.price.toLocaleString()}
                    </span>
                    <span className="text-xs font-Medium">تومان</span>
                  </div>
                </>
              )}
            </div>
            {item.is_max && (
              <div
                className={classNames(
                  'text-gray-800 text-sm font-Medium w-full  px-2',
                )}
              >
                تعداد دفعات استفاده از این طرح به پایان رسیده است.
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default PromotedList;
const iconConvertor: Record<string, string> = {
  'ارسال پیامک': 'icon-namesms',
  'پیشتاز سازی': 'icon-nameflag-2',
  متمایزسازی: 'icon-namedistinction',
  'تازه سازی': 'icon-nameup',
};
